// src/redux/actions/types.js

// Tipo di azione per prenotare un posto
export const BOOK_SEAT_SUCCESS = 'BOOK_SEAT_SUCCESS';
export const FETCH_SEATS_SUCCESS = 'FETCH_SEATS_SUCCESS';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';
export const FETCH_ROOMS_SUCCESS = 'FETCH_ROOMS_SUCCESS';